import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

export type PageRestrictionsExperimentCohort = 'test' | 'control' | 'none';

// returns the experiment cohort
export const getPageRestrictionsExperimentCohort = (
	fireExperimentExposure: boolean = false,
): PageRestrictionsExperimentCohort => {
	const [expConfig, fireExposureEvent] = UNSAFE_noExposureExp('cc_page_restrictions_upsell_design');

	fireExperimentExposure && fireExposureEvent();

	return expConfig.get(
		'cohort',
		'none',
		(value: unknown): value is PageRestrictionsExperimentCohort =>
			value === 'none' || value === 'test' || value === 'control',
	) as PageRestrictionsExperimentCohort;
};
